import Yup, { generateAddressValidation } from '../yup';

const respondent = {
  resp_det_giv_nam: Yup.string()
    .csvGivenName(true) // This allows spaces, but only in EVR applications
    .required("Respondent's first name is required"),
  resp_det_fam_nam: Yup.string()
    .trim()
    .required("Respondent's last name is required"),
  resp_det_other_names: Yup.string(),
  resp_addr_known: Yup.string().required(
    "Please provide the respondent's current or last known address or select 'I don't know where the respondent lives'"
  ),
  resp_addr_known_pc: Yup.string().when('resp_addr_known', {
    is: (resp_addr_known: string) => resp_addr_known === 'unknown',
    then: Yup.string().required(
      "Please indicate whether the respondent's address is known to the police"
    ),
  }),
  ...generateAddressValidation('resp_det_addr', 'resp_addr_known', 'address'),
  resp_cont: Yup.array().ensure().test(
    'phone-group-validation',
    'Please enter at least one phone number',
    function (value) {
      if (!value || !value.includes('phone')) {
        return true; // No phone validation needed if phone option not selected
      }
      const { resp_cont_phone_3, resp_cont_phone, resp_cont_phone_2 } = this.parent;
      return !!(resp_cont_phone_3 || resp_cont_phone || resp_cont_phone_2);
    }
  ),
  resp_cont_phone_3: Yup.string().when('resp_cont', {
    is: (resp_cont: string[]) => resp_cont && resp_cont.includes('phone'),
    then: Yup.string().ausMobilePhone(),
  }),
  resp_cont_phone: Yup.string().when('resp_cont', {
    is: (resp_cont: string[]) => resp_cont && resp_cont.includes('phone'),
    then: Yup.string().ausPhone(),
  }),
  resp_cont_phone_2: Yup.string().when('resp_cont', {
    is: (resp_cont: string[]) => resp_cont && resp_cont.includes('phone'),
    then: Yup.string().ausPhone(),
  }),
  resp_cont_email: Yup.string().when('resp_cont', {
    is: (resp_cont: string[]) => resp_cont && resp_cont.includes('email'),
    then: Yup.string()
      .required('Please enter an email address')
      .email('Please enter a valid email address (example@domain.com)'),
  }),
  resp_cont_other: Yup.string().when('resp_cont', {
    is: (resp_cont: string[]) => resp_cont && resp_cont.includes('other'),
    then: Yup.string().required('Please enter additional contact details'),
  }),
  resp_weapon_access: Yup.string()
    .trim()
    .required(
      'Please indicate whether the respondent has access to weapons or firearms'
    ),
  resp_det_dob: Yup.string()
    .trim()
    .transform((value?: string) => (value ? value : undefined))
    .nullable()
    .notRequired()
    .csvDate()
    .birthdate(),
};

export default respondent;